import { GetReferralProgramEntity } from 'services/openapi';
import * as Yup from 'yup';

export const structure = (initData?: GetReferralProgramEntity | undefined) => [
  {
    name: 'pointSenderPhoneNumber',
    defaultValue: initData?.pointSenderPhoneNumber,
    label: 'Số điện thoại',
    validate: Yup.string()
      .required('Vui lòng nhập số điện thoại')
      .matches(
        /^0\d{9}$/,
        'Số điện thoại không hợp lệ, vui lòng nhập số điện thoại bắt đầu bằng số 0 và có 10 chữ số',
      ),
  },
  {
    name: 'referralPoint',
    defaultValue: initData?.referralPoint,
    label: 'Số điểm thưởng',
    validate: Yup.string().required('Vui lòng nhập số điểm thưởng'),
  },
  {
    name: 'startDate',
    defaultValue: initData?.startDate,
    label: 'Ngày bắt đầu',
    validate: Yup.string()
      .required('Vui lòng chọn ngày bắt đầu')
      .test(
        'comp-fromdate-todate',
        'Ngày & giờ bắt đầu phải nhỏ hơn Ngày & giờ kết thúc',
        function (value) {
          if (value)
            return (
              new Date(value).getTime() <
              new Date(this.parent?.endDate).getTime()
            );
          return false;
        },
      ),
  },
  {
    name: 'endDate',
    defaultValue: initData?.endDate,
    label: 'Ngày kết thúc',
    validate: Yup.string()
      .required('Vui lòng chọn ngày kết thúc')
      .test(
        'comp-fromdate-todate',
        'Ngày & giờ kết thúc phải lớn hơn Ngày & giờ bắt đầu',
        function (value) {
          if (value)
            return (
              new Date(this.parent?.startDate).getTime() <
              new Date(value).getTime()
            );
          return false;
        },
      ),
  },
  {
    name: 'autoActiveDate',
    defaultValue: initData?.autoActiveDate,
    label: 'Ngày tự động kích hoạt',
    validate: Yup.string().required('Vui lòng chọn ngày tự động kích hoạt'),
  },
  {
    name: 'active',
    defaultValue: initData?.active,
    label: 'Trạng thái',
    validate: Yup.string().required('Vui lòng chọn trạng thái'),
  },
];
